import Vue from 'vue'
import VueRouter from 'vue-router'
import SvgIcon from 'vue-svgicon'
import Velocity from 'velocity-animate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueApexCharts from 'vue-apexcharts'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import AsyncComputed from 'vue-async-computed'
import VueLodash from 'vue-lodash'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';




Vue.component('prism-editor', PrismEditor);

import store from './store.js'

import axios from 'axios'


import '@/axios.js';



import Drag from './components/Drag'
import Drop from './components/Drop'

Vue.component('drag', Drag);
Vue.component('drop', Drop);



import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)



Vue.use(VueLodash)

// Prototypes?

import Date from './components/prototypes/Date'










// Components
import Page from './components/Page'
import SideWindow from './components/SideWindow'

Vue.component('page', Page);
Vue.component('side-window', SideWindow);

// Views
import ButtonView from './components/views/new/ButtonView'
import CheckView from './components/views/CheckView'
import ClockPopupView from './components/views/ClockPopupView'
import ClockSelectView from './components/views/ClockSelectView'
import ClockView from './components/views/ClockView'
import ContextPopupView from './components/views/ContextPopupView'
import DatePickerView from './components/views/DatePickerView'
import DateSelectView from './components/views/DateSelectView'
import DragSourceView from './components/views/DragSourceView'
import DragTargetView from './components/views/DragTargetView'
import IconButtonView from './components/views/IconButtonView'
import FullIconButtonView from './components/views/FullIconButtonView'
import ImageButtonView from './components/views/ImageButtonView'
import ListView from './components/views/ListView'
import NavigationView from './components/views/NavigationView'
import MobileNavigationView from './components/views/MobileNavigationView'
import ObjectSearchView from './components/views/ObjectSearchView'
import PageTabsView from './components/views/PageTabsView'
import PhotoView from './components/views/PhotoView'
import PopupView from './components/views/PopupView'
import SearchBarView from './components/views/SearchBarView'
import SelectView from './components/views/new/SelectView'
import StatusView from './components/views/StatusView'
import StringView from './components/views/StringView'
import NumberView from './components/views/NumberView'
import SimpleNumberView from './components/views/SimpleNumberView'
import SwitchView from './components/views/new/SwitchView'
import SwitchArrayView from './components/views/SwitchArrayView'
import TableView from './components/views/TableView'
import TabsView from './components/views/new/TabsView'
import TextView from './components/views/TextView'
import EntitySelectView from './components/views/EntitySelectView'
import LazyEntitySelectView from './components/views/LazyEntitySelectView'
import CheckListView from './components/views/CheckListView'
import ButtonGroupView from './components/views/ButtonGroupView'
import SpinnerView from './components/views/SpinnerView'
import WindowListView from './components/views/WindowListView'
import DatePickerStdView from './components/views/DatePickerStdView'
import YesNoView from './components/views/YesNoView'
import WhiteFileListView from './components/views/WhiteFileListView'
import TaskSelectView from './components/views/TaskSelectView'
import KanbanView from './components/views/KanbanView'
import TaskView from './components/views/TaskView'
import TodoView from './components/views/TodoView'
import NewTableView from './components/views/NewTableView'

import WindowView from './components/views/new/WindowView'
import WindowStackView from './components/views/new/WindowStackView'
import CustomerSearchView from './components/views/new/CustomerSearchView'
import InlineTableView from './components/views/new/InlineTableView'
import InlineSelectView from './components/views/new/InlineSelectView'
import TagView from './components/views/new/TagView'
import LinesView from './components/views/new/LinesView'
import PhotosView from './components/views/new/PhotosView'

Vue.component('task-view', TaskView);
Vue.component('todo-view', TodoView);
Vue.component('kanban-view', KanbanView);
Vue.component('task-select-view', TaskSelectView);
Vue.component('white-file-list-view', WhiteFileListView);
Vue.component('button-view', ButtonView);
Vue.component('yes-no-view', YesNoView);
Vue.component('date-picker-std-view', DatePickerStdView);
Vue.component('check-view', CheckView);
Vue.component('clock-popup-view', ClockPopupView);
Vue.component('clock-select-view', ClockSelectView);
Vue.component('clock-view', ClockView);
Vue.component('context-popup-view', ContextPopupView);
Vue.component('date-picker-view', DatePickerView);
Vue.component('date-select-view', DateSelectView);
Vue.component('drag-source-view', DragSourceView);
Vue.component('drag-target-view', DragTargetView);
Vue.component('icon-button-view', IconButtonView);
Vue.component('full-icon-button-view', FullIconButtonView);
Vue.component('image-button-view', ImageButtonView);
Vue.component('list-view', ListView);
Vue.component('navigation-view', NavigationView);
Vue.component('mobile-navigation-view', MobileNavigationView);
Vue.component('object-search-view', ObjectSearchView);
Vue.component('page-tabs-view', PageTabsView);
Vue.component('photo-view', PhotoView);
Vue.component('popup-view', PopupView);
Vue.component('search-bar-view', SearchBarView);
Vue.component('select-view', SelectView);
Vue.component('status-view', StatusView);
Vue.component('string-view', StringView);
Vue.component('number-view', NumberView);
Vue.component('simple-number-view', SimpleNumberView);
Vue.component('switch-view', SwitchView);
Vue.component('switch-array-view', SwitchArrayView);
Vue.component('table-view', TableView);
Vue.component('tabs-view', TabsView);
Vue.component('text-view', TextView);
Vue.component('entity-select-view', EntitySelectView);
Vue.component('lazy-entity-select-view', LazyEntitySelectView);
Vue.component('check-list-view', CheckListView);
Vue.component('button-group-view', ButtonGroupView);
Vue.component('spinner-view', SpinnerView);
Vue.component('window-list-view', WindowListView);
Vue.component('svg-icon', SvgIcon);
Vue.component('window-view', WindowView);
Vue.component('window-stack-view', WindowStackView);
Vue.component('customer-search-view', CustomerSearchView);
Vue.component('inline-table-view', InlineTableView);
Vue.component('inline-select-view', InlineSelectView);
Vue.component('tag-view', TagView);
Vue.component('lines-view', LinesView);
Vue.component('photos-view', PhotosView);
Vue.component('new-table-view', NewTableView);




import ProjectWindowView from './components/views/new/windows/ProjectWindowView'
Vue.component('project-window-view', ProjectWindowView);

import TodoWindowView from './components/views/new/windows/TodoWindowView'
Vue.component('todo-window-view', TodoWindowView);

import ActivityWindowView from './components/views/new/windows/ActivityWindowView'
Vue.component('activity-window-view', ActivityWindowView);

import ClientWindowView from './components/views/new/windows/ClientWindowView'
Vue.component('client-window-view', ClientWindowView);

import SendWindowView from './components/views/new/windows/SendWindowView'
Vue.component('send-window-view', SendWindowView);

import UserWindowView from './components/views/new/windows/UserWindowView'
Vue.component('user-window-view', UserWindowView);

import JobWindowView from './components/views/new/windows/JobWindowView'
Vue.component('job-window-view', JobWindowView);

import CustomerWindowView from './components/views/new/windows/CustomerWindowView'
Vue.component('customer-window-view', CustomerWindowView);

import ManagerWindowView from './components/views/new/windows/ManagerWindowView'
Vue.component('manager-window-view', ManagerWindowView);

import GalleryWindowView from './components/views/new/windows/GalleryWindowView'
Vue.component('gallery-window-view', GalleryWindowView);



import UserWindow from './components/windows/UserWindow'
Vue.component('user-window', UserWindow);




import { HalfCircleSpinner } from 'epic-spinners';
Vue.component('half-circle-spinner', HalfCircleSpinner);



import ButtonView2 from './components/views/new/ButtonView'
Vue.component('button-view-2', ButtonView2);

import InputView2 from './components/views/new/InputView'
Vue.component('input-view', InputView2);

import LabelView from './components/views/new/LabelView'
Vue.component('label-view', LabelView);

import GridView from './components/views/new/GridView'
Vue.component('grid-view', GridView);

import MultiView from './components/views/new/MultiView'
Vue.component('multi-view', MultiView);

import PanelSepView from './components/views/new/PanelSepView'
Vue.component('panel-sep-view', PanelSepView);

import PanelView from './components/views/new/PanelView'
Vue.component('panel-view', PanelView);

import PopupStackView from './components/views/new/PopupStackView'
Vue.component('popup-stack-view', PopupStackView);

import PopupView2 from './components/views/new/PopupView'
Vue.component('popup-view-2', PopupView2);

import SwitchView2 from './components/views/new/SwitchView'
Vue.component('switch-view-2', SwitchView2);

import TabsView2 from './components/views/new/TabsView'
Vue.component('tabs-view-2', TabsView2);

import SelectView2 from './components/views/new/SelectView'
Vue.component('select-view-2', SelectView2);







import PlethoraTabsView from './components/views/plethora/TabsView'
Vue.component('plethora-tabs-view', PlethoraTabsView);

// App
import App from './App.vue'

// Layouts
import FormGridLayout from './components/layouts/FormGridLayout'
import FormLineLayout from './components/layouts/FormLineLayout'
import PageContentLayout from './components/layouts/PageContentLayout'
import TabbedPageLayout from './components/layouts/TabbedPageLayout'

Vue.component('form-grid-layout', FormGridLayout);
Vue.component('form-line-layout', FormLineLayout);
Vue.component('page-content-layout', PageContentLayout);
Vue.component('tabbed-page-layout', TabbedPageLayout);



import HomeLayout from './components/layouts/HomeLayout'

/*import SalesLayout from './components/layouts/SalesLayout'
import PlanningLayout from './components/layouts/PlanningLayout'
import FleetLayout from './components/layouts/FleetLayout'
import TrackingLayout from './components/layouts/TrackingLayout'
import WorkforceLayout from './components/layouts/WorkforceLayout'
import WarehouseLayout from './components/layouts/WarehouseLayout'
import BoxesLayout from './components/layouts/BoxesLayout'
import ClaimsLayout from './components/layouts/ClaimsLayout'*/

// Pages
//import DashboardPage from './components/pages/DashboardPage'

//import ContactsPage from './components/pages/ContactsPage'

import LoginPage from './components/pages/LoginPage'
//import ClaimFormPage from './components/pages/ClaimFormPage'
import NotFoundPage from './components/pages/NotFoundPage'

//import SalesLeadsPage from './components/pages/SalesLeadsPage'
//import SalesProductsPage from './components/pages/SalesProductsPage'
/*import SalesProductGroupsPage from './components/pages/SalesProductGroupsPage'
import SalesQuotesPage from './components/pages/SalesQuotesPage'
import SalesOrdersPage from './components/pages/SalesOrdersPage'
import SalesStatisticsPage from './components/pages/SalesStatisticsPage'*/

import CalendarPage from './components/pages/CalendarPage'
import InvoicingPage from './components/pages/InvoicingPage'
import InboxPage from './components/pages/InboxPage'
import OutboxPage from './components/pages/OutboxPage'
import StatisticsPage from './components/pages/StatisticsPage'
import UsersPage from './components/pages/UsersPage'
/*import PlanningReservationsPage from './components/pages/PlanningReservationsPage'

import FleetTrackingPage from './components/pages/FleetTrackingPage'
import FleetVehiclesPage from './components/pages/FleetVehiclesPage'
import FleetTrackerListPage from './components/pages/FleetTrackerListPage'
import FleetGeofencingPage from './components/pages/FleetGeofencingPage'

import WorkforceLeavePage from './components/pages/WorkforceLeavePage'
import HoursPage from './components/pages/HoursPage'
import WorkforceEmployeesPage from './components/pages/WorkforceEmployeesPage'
import WorkforceStatisticsPage from './components/pages/WorkforceStatisticsPage'

import WarehouseOverviewPage from './components/pages/WarehouseOverviewPage'
import WarehouseUnitsPage from './components/pages/WarehouseUnitsPage'
import WarehouseLocationsPage from './components/pages/WarehouseLocationsPage'
import WarehouseContractsPage from './components/pages/WarehouseContractsPage'

import BoxesStatusPage from './components/pages/BoxesStatusPage'
import BoxesStatisticsPage from './components/pages/BoxesStatusPage'

import ClaimsCasesPage from './components/pages/ClaimsCasesPage'
import ClaimsStatisticsPage from './components/pages/ClaimsStatisticsPage'*/

//import LogPage from './components/pages/LogPage'



import './icons'

Vue.config.productionTip = false

Vue.use(PerfectScrollbar);
Vue.use(AsyncComputed);
Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(SvgIcon);
Vue.use(VueApexCharts);
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyAGbTuGIsmVYpWfrOfhJNyxoDQbZzxBnRs'
	}
});

Vue.component('apexchart', VueApexCharts);

Object.defineProperty(Vue.prototype, '$velocity', { value: Velocity });








Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})






Vue.filter('optional', function (value) {
	return value === null ? '-' : value;
});

Vue.filter('date', function (value) {
	if (value == null) return '';
	var d = Date.normDate(value);

	console.log('date', d, value);

	return d.format('d-m-Y');
});

Vue.filter('timestamp', function (value) {
	if (value == null) return '';
	var d = Date.normDate(value);

	console.log('date', d, value);

	return d.format('d-m-Y, kl H:i');
});

Vue.filter('timestamp_s', function (value) {
	if (value == null) return '';
	var d = Date.normDate(value);

	console.log('date', d, value);

	return d.format('d-m-Y, kl H:i:s');
});

Vue.filter('unix_timestamp_s', function (value) {
	if (value == null) return '';
	var d = new Date(parseFloat(value) * 1000);

	console.log('date', d, value);

	return d.format('d-m-Y, kl H:i:s');
});

Vue.filter('time', function (value) {
	return value;
});

Vue.filter('extractTime', function (value) {
	if (value == null) return '';
	var d = Date.normDate(value);

	console.log('date', d, value);

	return d.format('H:i');
});

Vue.filter('roundHours', function (value) {
	// HD is rounded to half hours
	const mul = 1.0 / 0.25;
	const r = Math.round(value * mul) / mul;

	//console.log('Got ' + value + ' rounded to ' + r);

	return r;
});

Vue.filter('formatHours', function (value) {
	const v = parseFloat(value);
	const t = Math.floor(v);
	return t + ' t ' + (Math.floor((v - t) * 60)).toString().padStart(2, '0') + ' m';
});

Vue.filter('duration', function (value) {
	var t = Math.floor(value / 60);
	return t + (t == 1 ? ' time ' : ' timer ') + (value % 60) + ' min';
});

Vue.filter('integer', function (value) {
	return new Intl.NumberFormat('da-DK', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(value);
});

Vue.filter('number', function (value, decimals) {
	return new Intl.NumberFormat('da-DK', {
		minimumFractionDigits: decimals !== undefined ? decimals : 2,
		maximumFractionDigits: decimals !== undefined ? decimals : 2
	}).format(value);
});

Vue.filter('translate', function (value) {
	var dict = {
		'individual': 'Individual',
		'business': 'Business'
	};

	return dict[value];
});

Vue.filter('float', function (value) {
	return value;
});

Vue.filter('wrapDecimal', function (value) {
	return value.toString().replace('.', ',');
});

Vue.filter('unwrapDecimal', function (value) {
	return value.toString().replace(',', '.');
});

Vue.filter('days', function (value) {
	var now = new Date();
	var d 	= new Date(value);
	var n 	= Math.ceil(Math.round(d - now) / (24 * 60 * 60 * 1000));
	var a 	= Math.abs(n);
	
	var s 	= '';

	if (n < -1) 	s = a + ' dage siden';
	if (n == - 1) 	s = 'I går';
	if (n == 0) 	s = 'I dag';
	if (n == 1)		s = 'I morgen';
	if (n > 1)		s = 'Om ' + a + ' dage';

	return s;
});

Vue.filter('striphtml', function (value) {
	if (!value) return '';
	return value.replace(/<\/?[^>]+>/ig, ""); 
});






Vue.directive('$model', {
    bind: function (el, binding, vnode) {
        el.oninput = () => (vnode.context[binding.expression] = el.value)
    }
})











function auth({next, router}) {
	console.log('auth');

	if (store.state.auth) {
		console.log('AUTH FOUND');
		return next();
	}	

	// Try to get in using local storage
	console.log('local stoprage', localStorage);
	if (localStorage.auth) {
		store.commit('auth', localStorage.auth);

		axios
			.get('/users/me/')
			.then(function (r) {
				if (r.data._embedded.roles.map((item) => { return item.id; }).includes('admin')) {
					store.commit('user', r.data);
				}				
			});		

		return next();
	}

	console.log('next', next());

	return router.push({
		path: '/da/login'
	});
}

var meta = {
	middleware: auth,
	mobile: false
};



const availablePages = [
	/*{
		label: 'Kalender',
		icon: 'calendar',
		badge: 0,
		name: 'calendar', 
		path: 'calendar', 
		component: CalendarPage,
		module: null,
		props: true,
		children: null,
		meta: meta
	},*/
	/*{
		label: 'Reservationer',
		badge: 0,
		name: 'reservations', 
		path: 'reservations', 
		component: PlanningReservationsPage,
		props: {
			root: 'planning'
		},
		meta: meta
	},*/
	{
		label: 'Aktivitet',
		icon: 'ecg',
		badge: 0,
		name: 'activity', 
		path: 'activity', 
		component: InboxPage,
		module: null,
		props: true,
		children: null,
		meta: meta
	},
	{
		label: 'Klienter',
		icon: 'sim',
		badge: 0,
		name: 'clients', 
		path: 'clients', 
		component: OutboxPage,
		module: null,
		props: true,
		children: null,
		meta: meta
	},
	{
		label: 'Brugere',
		icon: 'user',
		badge: 0,
		name: 'users', 
		path: 'users', 
		component: UsersPage,
		module: null,
		props: true,
		children: null,
		meta: meta
	}
];


var pages = [];

for (var i = 0; i < availablePages.length; ++i) {
	console.log('process', process.env.NODE_ENV);

	if ((!availablePages[i].mode) || availablePages[i].mode == process.env.NODE_ENV) {
		pages.push(availablePages[i]);
		console.log('mode', availablePages[i].mode);
	}
}

const router = new VueRouter({
	//base: '/:customer/:lang/',
	mode: 'history',
	routes: [
		{
			path: '/',
			redirect: {
				path: '/da'
			}
		},
		{
			path: '/:lang',
			name: 'home',
			component: HomeLayout,
			redirect: {
				name: 'activity'
			},
			children: pages.concat([
				{
					name: 'login',
					path: 'login',
					component: LoginPage
				}
			])
		},
		{
			path: '*',
			component: NotFoundPage
		}
	]
});








// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	// If no subsequent Middleware exists,
	// the default `next()` callback is returned.
	if (!subsequentMiddleware) return context.next;

	return (...parameters) => {
	// Run the default Vue Router `next()` callback first.
	context.next(...parameters);
	// Then run the subsequent Middleware with a new
	// `nextMiddleware()` callback.
	const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
	};
}









router.beforeEach((to, from, next) => {
	//console.log(from);

	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware)
		? to.meta.middleware
		: [to.meta.middleware];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({ ...context, next: nextMiddleware });
	}

	return next();
});









const tester = {
	explode: function () {
		console.log('BOOOOM!');
	}
};



console.log('env', process.env);





var event = function (event) {
	console.log(event);
	console.log('hmm');

	if (!(el == event.target || el.contains(event.target))) {
		vnode.context[binding.expression](event);
	}
};


Vue.directive('click-outside', {
	priority: 700,
	bind(el, binding, vnode) {
		document.addEventListener('click', event);
	},
	unbind(el) {
		document.removeEventListener('click', event);
	}
});





new Vue({
	el: '#app',
	render: h => h(App, {
		props: {
			langCode: 'da',
			pages: pages
		}
	}),
	router,
	store,
	tester
});//.$mount('#app');